import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { EventosPage } from './eventos';
import { NgCalendarModule } from 'ionic2-calendar';
import { EventosPageProvider } from './eventos.provider';
import { EventsProvider } from '../../providers/events/events';

@NgModule({
  declarations: [
    EventosPage,
  ],
  imports: [
    NgCalendarModule,
    IonicPageModule.forChild(EventosPage),
  ], 
  providers: [
    EventosPageProvider,
    EventsProvider
  ]
})
export class EventosPageModule { }



// WEBPACK FOOTER //
// ./src/pages/eventos/eventos.module.ts